import { render, staticRenderFns } from "./LineFrame.vue?vue&type=template&id=709fc89d&scoped=true&"
import script from "./LineFrame.vue?vue&type=script&lang=js&"
export * from "./LineFrame.vue?vue&type=script&lang=js&"
import style0 from "./LineFrame.vue?vue&type=style&index=0&id=709fc89d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709fc89d",
  null
  
)

export default component.exports